import type * as React from "react";

/** A fraction of the window as a CSS percentage. */
export const percent = (fraction: number) => `${fraction * 100}%`;

/**
 * Vertical geometry lives in the stylesheet (`--axis-height`, `--track-height`,
 * …); the markup only says which track a clip is on.
 */
export const trackVars = (track: number) =>
  ({ "--track": track }) as React.CSSProperties;
